export * from './selection-list';

import { ProgramSelectionListComponent } from './selection-list';

export const ProgramMolecules = [
    ProgramSelectionListComponent
];